<template>
  <div class="page">
    <div class="title flex">
      {{ activeGroup ? activeGroup.name : '全部REITs' }}
      <div style="margin-left: auto; margin-right: 0">
        <Download
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info"
          echartRefName="chaert1Ref" />
      </div>
    </div>
    <div class="page-line"></div>
    <div style="display: flex; align-items: center; margin-top: 16px; font-size: 14px">
      <CCascader
        v-if="!activeGroup"
        @CCascader_select_node="fnCCascader_select_val_chart3"
        :default="category_cascader_val_chart3"
        :checkStrictly="true"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        >选择类别
      </CCascader>
      <CCascader
        v-if="!activeGroup"
        style="margin-left: 16px"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code"
        placeholder="请选择个股"
        :collapsetags="true"
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <div style="display: flex; align-items: center; margin-left: 1em">
        自定义时间
        <DateTimePick v-model="date_2" :clearable="false" @change="dateTimePickChange2" />
      </div>
      <el-checkbox v-model="checked" />&nbsp;&nbsp;一年以上是否年化
    </div>
    <div style="margin-top: 30px" :style="{ '--tlcc': currentTheme === 'dark' ? '#fff' : '#666' }">
      <el-table
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        class="table1"
        :header-cell-style="tableStyle"
        :data="page_data"
        :height="hhhhhh"
        style="width: 100%"
        @row-contextmenu="rowContextmenu"
        @cell-click="fnClick"
        :cell-class-name="cellClassName">
        <el-table-column fixed width="40" type="index" />
        <el-table-column fixed width="105" label="代码" prop="reit_code" />
        <el-table-column fixed min-width="160" label="简称" prop="reitsName" />
        <el-table-column fixed width="120" label="板块" prop="category_2" sortable />
        <el-table-column fixed width="85" label="现价" prop="now_price" sortable />
        <el-table-column
          label="涨跌幅"
          width="135"
          prop="growth_rate"
          sortable
          class-name="line-bar5">
          <template slot-scope="scope">
            <div class="flex items-center justify-center h-full">
              <div :style="{ width: '60%' }" class="flex items-center h-full">
                <div
                  class="color-bar9 left"
                  :class="{ 'opacity-0': scope.row.growth_rate >= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) *
                        x10() || 0.01
                    ),
                  }"></div>
                <div class="line"></div>
                <div
                  class="color-bar9 right"
                  :class="{ 'opacity-0': scope.row.growth_rate <= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) *
                        x10() || 0.01
                    ),
                  }"></div>
              </div>
              <div class="flex-1 text-left">
                {{ scope.row.growth_rate | pct }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="now_amt" label="成交额(万元)" width="175" sortable>
          <template slot-scope="scope">
            <div class="flex items-center" style="margin-left: 20px">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5150bf',
                  '--w': calcPx(normalizeNew(scope.row.now_amt, data_info.now_amt) * x10()),
                }"></div>
              <div>{{ scope.row.now_amt | amt6 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="170"
          label="换手率(不含大宗)"
          prop="turnover"
          sortable
          class-name="line-bar5">
          <template slot-scope="scope">
            <div class="flex items-center justify-center h-full">
              <div :style="{ width: '60%' }" class="flex items-center h-full">
                <div
                  class="color-bar9 left"
                  :class="{ 'opacity-0': scope.row.turnover >= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.turnover), data_info.turnover) * x10() || 0.01
                    ),
                  }"></div>
                <div class="line"></div>
                <div
                  class="color-bar9 right"
                  :class="{ 'opacity-0': scope.row.turnover <= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.turnover), data_info.turnover) * x10() || 0.01
                    ),
                  }"></div>
              </div>
              <div class="flex-1 text-left">
                {{ scope.row.turnover | pct }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="1D" label="1D" width="90" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['1D'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="1W" label="1W" width="90" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['1W'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="1M" label="1M" width="90" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['1M'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="3M" label="3M" width="90" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['3M'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="6M" label="6M" width="90" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['6M'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="YTD" label="YTD" width="95" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row.YTD | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="2024" label="2024" width="95" class-name="color-box" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row['2024'] | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="MAX" width="95" class-name="color-box" prop="MAX" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row.MAX | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="自定义" width="95" class-name="color-box" prop="customize" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row.customize | pct }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="流通市值(亿元)" width="155" prop="market_cap_float" sortable>
          <template slot-scope="scope">
            <div class="flex items-center">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5ae8ed',
                  '--w': calcPx(
                    normalizeNew(scope.row.market_cap_float, data_info.market_cap_float) * x10()
                  ),
                }"></div>
              <div>{{ scope.row.market_cap_float | fix9 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="市值(亿元)" prop="market_cap" sortable width="150">
          <template slot-scope="scope">
            <div class="flex items-center">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5ae8ed',
                  '--w': calcPx(normalizeNew(scope.row.market_cap, data_info.market_cap) * x10()),
                }"></div>
              <div>{{ scope.row.market_cap | fix9 }}</div>
            </div>
          </template></el-table-column
        >
        <el-table-column label="目前分派率" prop="div_yield" sortable width="160">
          <template #header>
            目前分派率
            <el-tooltip class="item" effect="dark" content="" placement="top">
              <div slot="content">
                数据备注：目前分派率为日内的<br />
                事实分派率估值，其中为最新的<br />
                可供分配金额ttm口径与对应的<br />
                最新股价计算的日内分派率
              </div>
              <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="flex items-center">
              <div
                v-if="scope.row.div_yield"
                class="color-bar"
                :style="{
                  '--bar_color': '#feb144',
                  '--w': calcPx(scope.row.div_yield * x10()),
                }"></div>
              <div v-if="scope.row.div_yield">{{ scope.row.div_yield | fix2_1 }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-set" @click="toggleCreateDialog">
        <i class="el-icon-plus" />
        设置自选
      </div>
      <!-- 表格右键菜单 -->
      <div
        class="tableContextmenu"
        :class="currentTheme"
        :style="tableContextmenuStyle"
        ref="menuRef"
        @click.stop="() => {}">
        <el-cascader-panel
          ref="aaa"
          :options="contextmenu_options"
          :props="{ expandTrigger: 'hover' }"
          @change="menuClick" />
      </div>
    </div>
    <Chart v-if="show_chart_1" :show="show_chart_1" @close="closeChart1" :info="activeRow" />
    <Loading :loading="loading" text="后台计算中，请稍等..." />
  </div>
</template>

<script>
import Download from '@/components/Basic/Download.vue';
import CCascader from '@/components/Basic/CCascader';
import DateTimePick from '@/components/Basic/DateTimePick';
import { getDateInfo, normalizeNew, number2Pct, numberFix2, sleep } from '@/utils';
import { fnReturnTableStyle } from '@/utils/util';
import Chart from './Chart.vue';
import Loading from '@/components/Basic/Loading.vue';

const calcPx = (n) => {
  const v = n * 70;
  return Math.min(v, 70) + 'px';
};
const getAll = (data, k, abs = false) => {
  const all = data.map((item) => {
    if (abs) return Math.abs(item[k]);
    return item[k];
  });
  let sum = 0;
  all.forEach((num) => (sum += num));
  return sum;
};

export default {
  props: { nav_list: Array },
  components: { CCascader, DateTimePick, Chart, Download, Loading },
  data() {
    const now = new Date();
    const today = new Date();
    today.setFullYear(today.getFullYear() - 1);
    const CATEGORYDATA = JSON.parse(localStorage.getItem('CATEGORYDATA')) || [];
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    return {
      fixhhhhh: 1,
      dButtonsDownloads: Object.freeze([
        /* {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      excel_info: Object.freeze({
        overviewName: '',
        excel_data: [],
        json_fields: {},
      }),
      loading: false,
      ROOTFONTFIZE: '',
      OFFSETHEIGHT: 0,
      category_cascader_val_chart3: ['公募REITs'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code: [],
      CODENAMEDATA: Object.freeze(REITsNAME),
      checked: false,
      date_2: [today, now],
      tableContextmenuStyle: {
        top: '-999px',
        left: '-999px',
      },
      //右键选中行
      activeRow: {},
      contextmenu_options: [],
      page_data: [],
      data_info: {},
      show_chart_1: false,
    };
  },
  computed: {
    hhhhhh() {
      return this.OFFSETHEIGHT - 395 - this.fixhhhhh;
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    qsStr() {
      const annualize = this.checked ? '1' : '0';
      const cal_function = 'single';
      const r_type = this.category_cascader_val_chart3.join('&r_type_=');
      let codes = this.reit_code.join('&codes=');
      let flag = 'all';
      if (this.activeGroup) {
        flag = 'group';
        const _activeGroup = this.activeGroup || { reit_codes: [] };
        const group_codes = _activeGroup.reit_codes.join('&codes=');
        codes = group_codes;
      }
      const start_date = getDateInfo(this.date_2[0]).dateString;
      const end_date = getDateInfo(this.date_2[1]).dateString;

      return `annualize=${annualize}&cal_function=${cal_function}&codes=${codes}&r_type_=${r_type}&date_=${start_date}&end_=${end_date}&flag=${flag}`;
    },
    activeGroup() {
      return this.nav_list.find((item) => item.active);
    },
  },
  watch: {
    nav_list: {
      handler: function (n) {
        this.hiddenMenu();
        const hasActive = n.find((item) => item.active);
        const base = [
          { value: '放大近期走势', label: '放大近期走势' },
          { value: '批量操作', label: '批量操作' },
        ];
        if (hasActive) {
          this.contextmenu_options = [...base, { value: '删除', label: '删除' }];
          if (hasActive.reit_codes.length === 0) {
            this.$message.warning('该自选股组合没有添加个券');
            this.page_data = [];
          }
        } else {
          this.contextmenu_options = [
            {
              value: '加入自选组合',
              label: '加入自选组合',
              children: n.map((item) => ({
                value: item.id,
                label: item.name,
              })),
            },
            ...base,
          ];
        }
      },
      immediate: true,
    },
    qsStr() {
      this.loadData();
    },
  },
  filters: {
    fix2_1(n) {
      if (n === '') return '';
      return numberFix2(n * 100) + '%';
    },
    pct(n) {
      if (n === '') return '';
      return number2Pct(n);
    },
    fix8(n) {
      if (n === '') return '';
      return numberFix2(n / 100000000, 3);
    },
    fix9(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 3);
    },
    amt6(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 2);
    },
  },
  methods: {
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const { label } = column;
      const is_hit = ['代码', '简称', '板块'].includes(label);
      if (is_hit) {
        return 'cursor-pointer';
      }
      return '';
    },
    x10() {
      if (this.activeGroup) {
        return 1;
      }
      return 10;
    },
    fnClick(row, column, cell) {
      const { label } = column;
      const is_hit = ['代码', '简称', '板块'].includes(label);
      if (!is_hit) return;
      if (row.reit_code) {
        let arr = [row['reitsName'], row['reit_code']];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    toggleCreateDialog() {
      this.$emit('toggleCreateDialog');
    },
    closeChart1() {
      this.show_chart_1 = false;
    },
    // 删除组中code
    async delGroupCode(id, code) {
      if (this.lock_del3) return;
      this.lock_del3 = true;
      const { data } = await this.$https.get(
        `/api/v2/delete_user_reit_baisc?group_id=${id}&reit_code=${code}`
      );
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_del3 = false;
        return;
      }
      const index = this.nav_list.findIndex((item) => item.active);
      this.$emit('loadGroups', index >= 0 ? index : undefined);
      this.$message.success('删除成功');
      await sleep(200);
      this.lock_del3 = false;
    },

    async loadData() {
      if (this.activeGroup && this.activeGroup.reit_codes.length === 0) {
        return;
      }
      this.loading = true;
      const { data } = await this.$https.get(`/api/v2_5/stacking_return_data?${this.qsStr}`);
      if (data.code !== 200) {
        this.loading = false;
        return this.$message.error(data.msg);
      }
      const stacking_map = data.data.reduce((p, c) => {
        p[c.reit_code] = c['总体回报'];
        return p;
      }, {});
      const { data: data2 } = await this.$https.get(`/api/v2_5/period_risk_single?${this.qsStr}`);
      if (data2.code !== 200) {
        this.loading = false;
        return this.$message.error(data2.msg);
      }
      data2.data.forEach((item) => {
        item.customize = stacking_map[item.reitsName];
      });
      this.page_data = Object.freeze(data2.data);
      this.data_info = Object.freeze({
        market_cap_float: getAll(data2.data, 'market_cap_float'),
        market_cap: getAll(data2.data, 'market_cap'),
        now_amt: getAll(data2.data, 'now_amt'),
        growth_rate: getAll(data2.data, 'growth_rate', true),
        turnover: getAll(data2.data, 'turnover'),
      });
      this.loading = false;
      this.updateDownload(data2.data);
      setTimeout(() => {
        if (this.fixhhhhh) {
          this.fixhhhhh = 0;
        } else {
          this.fixhhhhh = 1;
        }
      }, 200);
    },
    updateDownload(data) {
      this.excel_info = Object.freeze({
        overviewName: this.activeGroup ? this.activeGroup.name : '全部REITs',
        excel_data: data,
        json_fields: {
          代码: 'reit_code',
          简称: 'reitsName',
          板块: 'category_2',
          现价: 'now_price',
          涨跌幅: 'growth_rate',
          '成交额(万元)': 'now_amt',
          '换手率(不含大宗)': 'turnover',
          '1D': '1D',
          '1W': '1W',
          '1M': '1M',
          '3M': '3M',
          '6M': '6M',
          YTD: 'YTD',
          '2024 ': '2024',
          MAX: 'MAX',
          自定义: 'customize',
          '流通市值(亿元)': 'market_cap_float',
          '市值(亿元)': 'market_cap',
          目前分派率: 'div_yield',
        },
      });
    },

    calcPx,
    normalizeNew,
    number2Pct,

    hiddenMenu() {
      this.tableContextmenuStyle = {
        top: `-999px`,
        left: `-999px`,
      };
    }, // 股票加入自选组
    async groupAddCode(id, code) {
      if (this.lock_add3) return;
      this.lock_add3 = true;
      const { data } = await this.$https.get(
        `/api/v2/add_user_reit_baisc?group_ids=${id}&reit_codes=${code}`
      );
      this.$root.$emit('reloadCodeName2');
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_add3 = false;
        return;
      }
      const index = this.nav_list.findIndex((item) => item.active);
      this.$emit('loadGroups', index >= 0 ? index : undefined);
      this.$message.success('添加成功');
      await sleep(200);
      this.lock_add3 = false;
    },
    menuClick(data) {
      if (!data.length) return;
      if (data.length > 1) {
        if (data[0] === '加入自选组合') {
          this.groupAddCode(data[1], this.activeRow.reit_code);
        }
      } else {
        const v = data.toString();
        if (v === '批量操作') {
          this.$emit('toggleCreateDialog');
        }
        if (v === '删除') {
          const id = (this.activeGroup || {}).id;
          const code = this.activeRow.reit_code;
          this.delGroupCode(id, code);
        }
        if (v === '放大近期走势') {
          this.show_chart_1 = true;
        }
      }
      this.$refs.aaa.clearCheckedNodes();
      this.hiddenMenu();
    },
    rowContextmenu(row, column, event) {
      this.activeRow = row;
      const { clientX, clientY } = event;
      event.preventDefault();
      const menu_w = this.$refs.menuRef.clientWidth;
      let x = clientX;
      if (clientX >= window.screen.width - menu_w) {
        x -= menu_w;
      }
      if (this.$refs.aaa.menus.length > 1) {
        this.$refs.aaa.activePath = [];
        this.$refs.aaa.menus.pop();
      }
      this.tableContextmenuStyle = {
        top: `${clientY}px`,
        left: `${x}px`,
      };
    },
    dateTimePickChange2() {},
    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
      this.TABPANEHEIGHT = localStorage.getItem('TABPANEHEIGHT');
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1440 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      let OFFSETHEIGHT = element.offsetHeight;
      this.OFFSETHEIGHT = OFFSETHEIGHT;
    },
    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
  },
  mounted() {
    this.loadData();
    this.fnGetWidth();
    window.addEventListener('resize', this.fnGetWidth);
    window.addEventListener('click', this.hiddenMenu);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fnGetWidth);
    window.removeEventListener('click', this.hiddenMenu);
  },
};
</script>

<style scoped lang="less">
/deep/.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}

.page {
  color: var(--chart_title);
}

.title {
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  color: var(--el-header-text-color);
}
.page-line {
  width: 100%;
  margin-top: 16px;
  border-bottom: 1px dashed var(--el-header-text-color);
  opacity: 0.2;
}

.btn-set {
  cursor: pointer;
  display: inline-block;
  padding: 2px 5px;
  margin-top: 10px;
  font-size: calc(var(--ROOTFONTFIZE) * (12 / 144));
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

.title-slot {
  display: flex;
  justify-content: space-between;
  width: 45%;
  color: var(--chart_title);
}
.dialog-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .dialog-left {
    width: 45%;
    height: 480px;
    border: 1px solid #616161;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
    /deep/.el-input {
      margin-left: 0;
      input {
        color: var(--table_color);
        border: none;
        background-color: var(--Btn-bgc);
      }
    }
  }
  .dialog-right {
    width: 45%;
    height: 480px;
    border: 1px solid #616161;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
    .list {
      height: 440px;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: var(--scrollbar-thumb);
      }
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        padding: 12px;
        border-radius: 4px;
        background-color: var(--el-header-SsearchStyle-bgc);
        /deep/.el-checkbox {
          margin-left: 0;
        }
        .name {
          flex: 1;
          display: flex;
          cursor: pointer;
          margin-left: 10px;
          margin-right: 6px;
          color: var(--chart_title);
          line-height: 30px;
          .icon-wrap {
            margin-left: 4px;
            flex: none;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20px;
            height: 20px;
            font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
            border-radius: 100%;
            background-color: #999;
          }
          /deep/.el-input {
            margin-left: 0;
            input {
              border: none;
              outline: none;
              color: var(--chart_title);
              background-color: rgb(183, 183, 184);
              height: 30px;
            }
          }
        }
        .del {
          visibility: hidden;
          cursor: pointer;
          margin-right: 0;
          margin-left: auto;
          color: var(--primary-color);
          &.add {
            visibility: visible;
          }
        }
        &:hover {
          filter: brightness(0.9);
          .del {
            visibility: visible;
          }
        }
        &.add-item {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0;
          color: var(--primary-color);
          background-color: transparent;
          border: 1px dashed var(--primary-color);
          &.gray {
            cursor: default;
            filter: grayscale(1);
          }
        }
      }
    }
  }
  .btn-add {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    border-radius: 4px;
    color: var(--Btn-bgc2);
    background-color: var(--primary-color);
  }
}
.btn-confirm {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
  margin-top: 20px;
  width: 80px;
  height: 36px;
  border-radius: 4px;
  color: var(--Btn-bgc2);
  background-color: var(--primary-color);
}
/deep/.cust-dialog .el-dialog__body {
  border-top: none;
}

.tableContextmenu {
  position: fixed;
  z-index: 99;
  /deep/.el-cascader-panel {
    // height: 115px;
    height: auto;
  }
  /deep/.el-cascader-menu__wrap.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
  /deep/.el-scrollbar.el-cascader-menu {
    padding-bottom: 0;
  }
  /deep/.el-cascader-menu .is-active {
    font-weight: unset;
    .el-icon-check {
      display: none;
    }
  }
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.h-full {
  height: 100%;
}
/deep/.flex {
  display: flex;
}
/deep/.items-center {
  align-items: center;
}
/deep/.space-between {
  justify-content: space-between;
}
/deep/.justify-center {
  justify-content: center;
}
/deep/.color-bar {
  width: var(--w);
  min-width: 1px;
  height: 16px;
  margin-right: 10px;
  background-color: var(--bar_color);
}

/deep/.color-box {
  padding: 0 !important;
}
/deep/.color-box .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.color-box .cell > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // color: #fff;
  background-color: var(--box-color);
}
/deep/.line-bar5 {
  padding: 0 !important;
}
/deep/.line-bar5 .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.flex-1 {
  flex: 1;
}
.opacity-0 {
  opacity: 0;
}
/deep/.line {
  flex: none;
  width: 1px;
  height: 100%;
  border-left: 1px dashed var(--tlcc, #fff);
}
/deep/.text-left {
  text-align: left;
}

/deep/.color-bar9 {
  width: 50%;
  height: 16px;
  &.left {
    background: linear-gradient(to left, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
  &.right {
    background: linear-gradient(to right, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
}

.el-table {
  padding-bottom: 0 !important;
}
/deep/ .el-table table {
  border: none !important;
}
/deep/ .el-table__fixed::before {
  background-color: transparent !important;
}
</style>
